export const getLastMultipleChoiceAnswer = exercise => {
  var _exercise$progress;
  const lastAttempt = (_exercise$progress = exercise.progress) === null || _exercise$progress === void 0 ? void 0 : _exercise$progress.last_attempt;
  if (lastAttempt == null) {
    return undefined;
  }
  if (exercise.question.flavor === 'MultipleChoice') {
    var _exec;
    const choiceStr = (_exec = /\d+/.exec(lastAttempt)) === null || _exec === void 0 ? void 0 : _exec[0];
    const currentChoice = choiceStr != null ? parseInt(choiceStr, 10) : undefined;
    return currentChoice != null ? currentChoice - 1 : undefined;
  }
  return undefined;
};